import type { OptiReasoningData } from './types'

export const MOCK_REASONING_DATA: OptiReasoningData = {
  prefixSuggestion: {
    prefix: 'DN - Correspondence',
    description: 'This is a document received via fax and/or lockbox.',
  },
  carcSuggestions: [
    {
      code: '197',
      description: 'Authorization Missing',
      reasoning:
        'The payer_response explicitly states the denial reason is that prior authorization was not obtained for services from a non-contracted provider. The reason_for_denial confirms: "Non-contracted provider services without prior authorization." CARC 197 with RARC M62 is the appropriate code.',
      extractedQuotes: [
        'services from non-contracted providers require prior authorization',
        'No prior authorization was obtained',
      ],
      isDenied: true,
    },
    {
      code: '29',
      description: 'Timely Filing',
      reasoning:
        'The payer_response explicitly states "Claim denied - not submitted timely" and the reason_for_denial confirms "Claim was not submitted timely." This is a CLAIM timely filing issue, not an appeal timely filing issue. Therefore CARC 29 applies.',
      extractedQuotes: ['Claim denied - not submitted timely', 'not submitted timely'],
      isDenied: true,
    },
  ],
  reasoningBlocks: [
    {
      tags: ['ATFL30', 'AURGENT', 'BRCDLTR', 'APFAX', 'FIRREQ'],
      bulletPoints: [
        "The document was classified as a phase: claim appeal with a reason: timely filing so I'm selecting timeline-specific tags prefixed with A.",
      ],
      extractedQuotes: [
        '30 days to file an appeal',
        'passed the timely filing limit',
        'claim appeal has been denied',
      ],
    },
    {
      tags: ['Appeal', 'Timely Filing', '30 days', '60 days'],
      bulletPoints: [
        'The document structure and headers indicate a formal challenge to a prior determination; selecting the Appeal phase tag.',
        "The payor's denial reason is specifically attributed to the submission date exceeding the allowed window; selecting the Timely Filing reason tag.",
        'Detected a filing deadline requirement for the provider/member; selecting the Time to Respond tag based on the identified window.',
        'The document specifies a regulatory or contractual period for the payor to issue a determination; selecting the Response Timeline tag.',
      ],
      extractedQuotes: [
        '30 days to file an appeal',
        'passed the timely filing limit',
        'must be received within 30 days of this letter',
        'allow 60 days for processing',
      ],
    },
    {
      tags: ['First Request', 'Barcode', 'Fax'],
      bulletPoints: [
        "The document lacks 'Second' or 'Final' notice indicators and follows the initial dispute sequence; selecting First Request for the request level.",
        'opti Logic: "Detected a machine-readable routing element or unique tracking ID on the document; selecting the Barcode requirement tag to ensure automated processing.',
        'Identified a designated fax number or transmission instruction within the submission requirements; selecting Fax as the primary delivery channel.',
      ],
      extractedQuotes: [
        'submission by fax is required for expedited review',
        'initial request for reconsideration',
      ],
    },
  ],
}
